import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpansionPanelComponent } from './expansion-panel.component';
import { MaterialModule } from '../../material/material.module';



@NgModule({
  declarations: [
    ExpansionPanelComponent
  ],
  imports: [
    CommonModule,MaterialModule
  ],
  exports:[
    ExpansionPanelComponent
  ]
})
export class ExpansionPanelModule { }
